"use client"

import logger from "@/lib/logger/logger-init"
import { type Result, ResultFactory } from "@/types/generic/Result"
import { type AddToCartResult } from "@/app/api/centra/add-item-to-selection/route"

export { type AddToCartResult }

export const addItemToSelection = async (
    formData: FormData,
    locale?: string
): Promise<Result<AddToCartResult>> => {
    try {
        const item = formData.get("item") as string

        if (!item) {
            return ResultFactory.failure<AddToCartResult>(new Error("Item is required"))
        }

        const addToCartResponse = await fetch("/api/centra/add-item-to-selection", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ item, locale })
        })

        const addToCartResult: Result<AddToCartResult> = await addToCartResponse.json()

        if (!addToCartResponse.ok) {
            logger.error("Failed to add item to cart", {
                status: addToCartResponse.status,
                error: addToCartResult
            })
            return ResultFactory.failure<AddToCartResult>(
                new Error("Failed to add item to cart")
            )
        }

        return addToCartResult
    } catch (error) {
        logger.error("Error in addItemToCart", {
            error: error instanceof Error ? error.message : String(error)
        })
        return ResultFactory.failure<AddToCartResult>(
            error instanceof Error ? error : new Error("Unknown error occurred")
        )
    }
}
